import React, { useEffect, useState } from 'react';
import { shouldRenderComponent } from './helpers';
import { useLoginContext } from '../../App';
import { useContentContext } from '../layout/Layout';
import { showNotification } from './Notification';
import useB2BTranslation from './hooks/useB2BTranslation';

const ProtectedElement = ({ rolesAllowed = [], b2bProduct = [], children }) => {
    const { t } = useB2BTranslation('b2b-common');
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const [notificationShown, setNotificationShown] = useState(false);

    useEffect(() => {
        if (!shouldRenderComponent(loginData, rolesAllowed, b2bProduct) && !notificationShown) {
            showNotification(setNotification, t('You do not have permission to view this!'), 'error', 5000);
            setNotificationShown(true);
        }
    }, [loginData, rolesAllowed, b2bProduct, setNotification, notificationShown]);

    if (!shouldRenderComponent(loginData, rolesAllowed, b2bProduct)) {
        return <></>;
    }

    return (
        children
    );
};

export default ProtectedElement;